module.exports = __webpack_public_path__ + "img/booklet-mockup-mobile.cb286de1.png";